var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded-xl divide-y divide-gray-300 mt-6 sm:mt-10"},_vm._l((_vm.organizations),function(organization){return _c('OrganizationRow',{key:organization.id,attrs:{"organization":organization}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }